var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: 28,
    height: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.89 2.675C20.944.163 16.423.522 13.63 3.444 10.785.522 6.265.164 3.319 2.675c-3.81 3.23-3.251 8.51-.508 11.329L11.7 23.18c.507.512 1.168.82 1.93.82.71 0 1.371-.308 1.879-.82l8.94-9.176c2.692-2.82 3.25-8.1-.559-11.329Zm-1.22 9.586-8.888 9.176c-.101.102-.203.102-.355 0l-8.89-9.176c-1.879-1.897-2.234-5.485.356-7.69 1.981-1.69 5.029-1.435 6.959.513L13.63 6.93l1.777-1.846c1.88-1.948 4.927-2.204 6.908-.563 2.59 2.255 2.235 5.843.356 7.74Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.661397ca.svg";
export { ForwardRef as ReactComponent };